import type { Placement } from "@popperjs/core/lib/enums";
import React from "react";
import { SupTooltip } from "@repo/core-ui";

export interface UiTooltipProps {
  content: string | React.JSX.Element;
  arrowPlacement?: Placement;
  className?: string;
  popperClassName?: string;
  color?: "primary" | "info" | "error" | "warning" | "success" | "default";
  children: React.JSX.Element;
  as?: string;
  enable?: boolean;
  wrapper?: boolean;
}

export default function UiTooltip({
  as = "div",
  children,
  content,
  className,
  popperClassName,
  arrowPlacement,
  enable = true,
  color = "primary",
  wrapper = false,
}: UiTooltipProps) {
  return enable ? (
    <SupTooltip as={as} color={color} placement={arrowPlacement} className={className} unmount portal popperElClassName={popperClassName} wrapper={wrapper} content={content}>
      {children}
    </SupTooltip>
  ) : (
    children
  );
}
